@if (embedData && embedData.projects && embedData.projects[selectedProjectIndex]) {
  <div class="relative w-full flex justify-center items-center">
    <p class="text-gray-800 dark:text-white font-semibold text-xs lg:text-base">
      {{ embedData.projects[selectedProjectIndex].title }}
    </p>
  </div>

  <div class="relative w-full h-24 flex flex-row justify-between">
    <button
      class="w-8 h-full flex-none flex justify-center items-center"
      [disabled]="selectedProjectIndex === 0"
      (click)="onClickPreviousProject()"
    >
      <div
        class="flex justify-center items-center text-gray-800 dark:text-white text-3xl disabled:text-gray-800/60"
      >
        <mat-icon [inline]="true">arrow_left</mat-icon>
      </div>
    </button>
    <div class="relative w-full h-full">
      <img
        class="relative w-full h-full object-cover"
        [src]="embedData.projects[selectedProjectIndex].thumbnail"
        alt=""
      />
    </div>
    <button
      class="w-8 h-full flex-none flex justify-center items-center"
      [disabled]="selectedProjectIndex === embedData.projects.length - 1"
      (click)="onClickNextProject()"
    >
      <div
        class="flex justify-center items-center text-gray-800 dark:text-white text-3xl disabled:text-gray-800/60"
      >
        <mat-icon [inline]="true">arrow_right</mat-icon>
      </div>
    </button>
  </div>
}
